import { REPORTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';

export enum REPORTS_META_TITLES {
  MGA_PAGE = 'MGA',
  MGA_REAL_MONEY_BALANCE_PAGE = 'MGA Real Money Balance',
}

export const REPORTS_SECTIONS_ROUTES_META_TITLES = {
  [REPORTS_SECTIONS_ROUTES.MGA]: REPORTS_META_TITLES.MGA_PAGE,
  [REPORTS_SECTIONS_ROUTES.MGA_REAL_MONEY_BALANCE]: REPORTS_META_TITLES.MGA_REAL_MONEY_BALANCE_PAGE,
};
